import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ShoppingBag, Heart, ExternalLink } from 'lucide-react';

const APPMAX_LINK = 'https://pay.finaliza.shop/pl/525057dd65';

export function VirtualBagModal({ open, onClose }) {
  const handleDonate = () => {
    window.open(APPMAX_LINK, '_blank');
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" data-testid="virtual-bag-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ShoppingBag className="h-5 w-5 text-rose-600" />
            Sacola Virtual U-Clean
          </DialogTitle>
          <DialogDescription>
            Sua contribuição ajuda a manter a plataforma funcionando e apoia milhares de pessoas em recuperação.
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          {/* Informação de valor mínimo */}
          <div className="text-center mb-6">
            <p className="text-sm text-gray-600 mb-1">
              Contribua com qualquer valor a partir de
            </p>
            <p className="text-2xl font-bold text-rose-600">R$ 5,00</p>
            <p className="text-xs text-gray-500 mt-1">
              Múltiplos de R$ 5,00 · PIX ou Cartão
            </p>
          </div>

          {/* Botão DOE AQUI */}
          <Button
            onClick={handleDonate}
            className="w-full py-6 text-lg font-bold bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600"
            data-testid="donate-button"
          >
            <Heart className="h-5 w-5 mr-2" />
            DOE AQUI!
            <ExternalLink className="h-4 w-4 ml-2" />
          </Button>

          {/* Rodapé de segurança */}
          <p className="text-xs text-gray-500 text-center mt-4">
            Você será redirecionado para uma página segura da Appmax para concluir a doação via PIX ou Cartão.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
